import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * 目前使用者與有效權限 — GET /auth/me。
 * @see docs/API_AUTH.md
 */
export async function fetchMe() {
  const { data: raw } = await request.get('/auth/me');
  return parseVer4DetailResponse(raw);
}
